app.service('addToCartService', function (productCardManager, store, cartManager, productCardConfig, broker) {

	function init() {
		broker.on('ADD_TO_CART_WITHOUT_INSTALMENT', handleAddToCartWithoutInstalment);
		broker.on('ADD_TO_CART_PROMOTION_PACKAGE', function (e, data) { 
			add(data);
		});
	}

	function handleAddToCartWithoutInstalment(e, data) {
		const {services, partnerSubscription, productWarranty} = productCardManager.get();
		const partnerSubscriptionsIds = partnerSubscription.map(subscription => subscription.id);
		const outletCategoryId = store.data.isOutlet ? store.data.outletCategoryId : undefined;
		const warranty = productWarranty.warranty || undefined;
		const warrantyPaymentType = (productCardManager.hasWarranty() && productWarranty.warrantyPaymentType) || undefined;
		const warrantyAddedFrom = productWarranty.warrantyAddedFrom || undefined;
		const relatedPromotionServiceId = relatedPromotionServiceId || undefined;

		const defaultData = {
			productId: productCardConfig.getData().id,
			services,
			partnerSubscriptionsIds,
			outletCategoryId,
			isInstalment: false,
			warranty,
			warrantyPaymentType,
			warrantyAddedFrom,
			relatedPromotionServiceId
		};
		const options = $.extend({}, defaultData, data);
		cartManager.addProduct(options);
	}

	function add(data) {
		const {services, partnerSubscription, productWarranty} = productCardManager.get();
		const partnerSubscriptionsIds = partnerSubscription.map(subscription => subscription.id);
		const outletCategoryId = store.data.isOutlet ? store.data.outletCategoryId : undefined;
		let isInstalment = store.data.isInstalment ? store.data.isInstalment : false;
		let instalment = store.data.isInstalment ? store.data.instalmentCode : undefined;
		let instalmentNumber = store.data.isInstalment ? store.data.instalmentNumber : undefined;
		let paymentType = store.data.isInstalment ? store.data.instalmentPaymentType : undefined;
		const warranty = productWarranty.warranty || undefined;
		const warrantyPaymentType = (productCardManager.hasWarranty() && productWarranty.warrantyPaymentType) || undefined;
		const warrantyAddedFrom = (productCardManager.hasWarranty() && productWarranty.warrantyAddedFrom) || undefined;
		const relatedPromotionServiceId = data && data.relatedPromotionServiceId ? data.relatedPromotionServiceId : undefined;
		isInstalment = data && data.isInstalment ? data.isInstalment : isInstalment;
		instalment = data && data.instalment ? data.instalment : instalment;
		instalmentNumber = data && data.instalmentNumber ? data.instalmentNumber : instalmentNumber;
		paymentType = data && data.paymentType ? data.paymentType : paymentType;

		const options = {
			addedFrom: 'PRODUCT_CARD',
			productId: productCardConfig.getData().id,
			warranty,
			warrantyPaymentType,
			warrantyAddedFrom,
			services,
			partnerSubscriptionsIds,
			outletCategoryId,
			isInstalment,
			instalment,
			instalmentNumber,
			paymentType,
			relatedPromotionServiceId,
			productPLU: productCardConfig.getData().plu
		};
		cartManager.addProduct(options);
	}

	return {
		init,
		add
	};
});